import { Injectable } from "@angular/core";
import { CommonApiService } from "./common-api.service";
import { APIURL } from "../global/constant";

@Injectable({
  providedIn: "root",
})
export class StoryboardService {
  constructor(private commonApiService: CommonApiService) {}

  fetchStoryboardDetails(storyboardId: number | string) {
    return this.commonApiService.get(APIURL.storyboardDetails + storyboardId);
  }

  onGenerateStoryBoardShotImage(payload: any) {
    return this.commonApiService.post(APIURL.storyboardImageGenerate, payload);
  }

  uploadStoryImage(formData: FormData) {
    return this.commonApiService.post(APIURL.uploadStoryImage, formData);
  }

  uploadvideorefimage(formData: FormData) {
    return this.commonApiService.post(APIURL.uploadvideorefimage, formData);
  }
}
